import { Component, Inject } from '@angular/core';
import { faUser, faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@auth0/auth0-angular';
import { AsyncPipe, DOCUMENT, NgIf } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbCollapse,
  NgbDropdown,
  NgbDropdownMenu,
  NgbDropdownToggle,
} from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';
import { Subscription } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  standalone: true,
  imports: [
    FontAwesomeModule,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdown,
    NgbCollapse,
    AsyncPipe,
    NgIf,
    RouterLink,
  ],
})
export class NavBarComponent {
  isCollapsed = true;
  faUser = faUser;
  faPowerOff = faPowerOff;
  accessTokenSub?: Subscription;
  userInfoSub?: Subscription;

  constructor(
    public auth: AuthService,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  loginWithRedirect() {
    this.accessTokenSub = this.auth.getAccessTokenWithPopup().subscribe({
      next: async (res) => {
        await this._proccessTokenResult(res);
        // this.errorShown = false;  // Reseteamos la bandera si el proceso es exitoso
      },
      error: (err) => {
        // Evitar mostrar error si el popup es cerrado por el usuario
        if (err.error === 'popup_closed_by_user') {
          console.log('Pop-up de autenticación cerrado por el usuario.');
          return;  // No hacer nada si el pop-up fue cerrado
        }
  
        // Mostrar error solo si no es el caso de pop-up cerrado
        // if (!this.errorShown) {
        //   this.handleAuthError(err);
        //   this.errorShown = true;
        // }
      }
    });
  //  var test =  this.auth.loginWithRedirect();
  }

  logout() {
    this.auth.logout({ logoutParams: { returnTo: this.doc.location.origin } });
  }

  async _proccessTokenResult(res: string | undefined) {
    localStorage.setItem('access_token', res ?? '');
    const helper = new JwtHelperService();
    const decoded_token = helper.decodeToken(res ?? '');

    // await this.userSvc.setPermissions(decoded_token);

    this.userInfoSub = this.auth.user$.subscribe({
      next: (usr) => {
        // if (usr?.email_verified !== true) {
        //   this.userSvc.setPermissions(null);
        //   this.dispose();
        //   this.toastr.warning('¡Verifique su correo!', 'Para continuar debe verificar su email. Revise su casilla de correo.');
        //   return;
        // }

        // this.userSvc.user = usr;
        // this.userSvc.isLoggedIn = true;

        let queryParams: { [key: string]: string } = {};
        // this.activatedRoute.queryParams.subscribe(params => {
        //   if (params['returnUrl'])
        //     queryParams = this.getQueryParamsFromStringUrl(params['returnUrl']);
        // });

        // console.log('base: ', this.basePath);
        console.log('params: ', queryParams);

        // this.router.navigate([this.basePath], { queryParams: queryParams });
      },
      error: (err) => {
        // if (!this.errorShown) {
        //   this.toastr.error('Error en la autenticación', 'Ha ocurrido un error durante el proceso de autenticación.');
        //   this.errorShown = true;
        // }
      },
    });
  }
}
